import React from "react";
import { Card } from "@sscs/ui";
const Explanation = ({ explanation, }) => {
    if (!explanation)
        return null;
    return (React.createElement(Card.Card, null,
        React.createElement(Card.Title, null, "Behavior usually triggered by"),
        React.createElement(Card.Content, null, explanation)));
};
export default Explanation;
//# sourceMappingURL=Explanation.js.map